import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useStyles } from '../BasicInformation.style';
import { submitPassportRequest } from '../../../../CandidatePortal/actions/submitPassportRequest';
import { getPassportCta } from 'common/helpers/getPassportCta';

const getGenderText = (gender) => {
  let text;
  switch (gender) {
    case 1:
      text = 'Male';
      break;

    case 2:
      text = 'Female';
      break;

    case 3:
      text = 'Prefer not to say';
      break;

    default:
      break;
  }

  return text;
};

const PersonalDetails = (props) => {
  const classes = useStyles();

  const { isAnon, candidate, userInfo, sponsorUserId } = props;
  const { sponsorCode, user } = candidate;

  // The anon-passport CTA depends on the viewer's access. Someone who already has access (the owner
  // or the sponsor) gets a shortcut to the named passport; a logged-in account-holder without access
  // gets the real "Request passport" ask; and a public share view (no logged-in viewer) shows nothing
  // — see getPassportCta. NOTE: `candidate.user` is masked on the anon view (no id), so the owner id
  // comes from `candidate.userId`, which survives masking.
  const cta = getPassportCta({
    viewerId: userInfo && userInfo.id,
    ownerUserId: candidate.userId,
    sponsorUserId,
    isAnon,
  });

  const handleSubmitPassportRequest = () => {
    props.submitPassportRequest({
      userId: user.id,
      candidateId: candidate.id,
      feedback: 0,
    });
  };

  return (
    <>
      {cta === 'view-full' ? (
        <Alert severity="info" elevation={6} variant="filled">
          <Typography>You already have access to this passport.</Typography>
          <Button
            component={Link}
            to={`/passport/${candidate.id}`}
            variant="contained"
            color="primary"
            size="small"
          >
            View full passport
          </Button>
        </Alert>
      ) : null}
      {cta === 'request' ? (
        <Alert severity="warning" elevation={6} variant="filled">
          <Typography>Anonymous passport - For full details:</Typography>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSubmitPassportRequest}
          >
            Request passport
          </Button>
        </Alert>
      ) : null}
      <Grid container className={isAnon ? classes.backDrop : ''}>
        <Grid item xs={5}>
          <Typography variant="body2" color="textPrimary">
            Name:
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" className={classes.content}>
            {user.firstName} {user.lastName}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" color="textPrimary">
            Gender:
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" className={classes.content}>
            {getGenderText(user.gender)}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" color="textPrimary">
            DOB:
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" className={classes.content}>
            {user.dateOfBirth}
          </Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography variant="body2" color="textPrimary">
            Contact Email:
          </Typography>
        </Grid>
        <Grid item xs={7}>
          <Typography variant="body1" className={classes.content}>
            {user.email}
          </Typography>
        </Grid>
        {sponsorCode ? (
          <>
            <Grid item xs={5}>
              <Typography variant="body2" color="textPrimary">
                Sponsor Code:
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography variant="body1" className={classes.content}>
                {sponsorCode}
              </Typography>
            </Grid>
          </>
        ) : null}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  userInfo: state.dashboard.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
  submitPassportRequest: (params, callback) =>
    dispatch(submitPassportRequest(params, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalDetails);
